export const isEqualIndex = (length: number, index: number) => {
  return length === index + 1;
};

export const isNotEqualIndex = (length: number, index: number) => {
  return length !== index + 1;
};
